<template><div><h1 id="corris-import-parametrisierung" tabindex="-1"><a class="header-anchor" href="#corris-import-parametrisierung"><span>Corris-Import: Parametrisierung</span></a></h1>
<p>Corris-Import: Parametrisierung — Einstellungen für Zusagen-Import</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden die Parameter für den Import von externen Zusagen eingetragen.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Corris → Zusagen-Import Parametrisierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Ext. Zusage</dt>
<dd>Bezeichnung der Zusage in der Quelldatei.</dd>
<dt>Zusageart</dt>
<dd><RouteLink to="/referenz/refs/ft.refdata.tblzusart.html">Zusageart</RouteLink> in funtrade.</dd>
<dt>Zahlungsdatum</dt>
<dd>Die Parametrisierungs-Zeile gilt für Zahlungen mit Datum bis ...</dd>
<dt>zusagen-Typ</dt>
<dd>Die Parametrisierungs-Zeile gilt für diesen Zusagentyp, leer =&quot;alle&quot;</dd>
<dt>Akquisitionscode</dt>
<dd><RouteLink to="/referenz/refs/ft.refdata.tblakquicode.html">Akquisitionscode</RouteLink> der zu erfassenden Zusage.</dd>
<dt>Eintrittsgrund</dt>
<dd>Eintrittsgrund Corris, kann direkt einem Akquicode zugeordnet werden.</dd>
<dt>Ereignis-Nr.</dt>
<dd>Ereignis der Zahlungen</dd>
<dt>Pos-Nr.</dt>
<dd>Ereignisposition der Zahlungen</dd>
<dt>Typ/Kat</dt>
<dd>Ereignistyp/Kategorie der Zahlung</dd>
<dt>Ereignis-Nr. Widerruf</dt>
<dd>Ereignis der Widerrufe</dd>
<dt>Pos-Nr. Widerruf</dt>
<dd>Ereignisposition der Widerrufe</dd>
<dt>Typ/Kat Widerruf</dt>
<dd>Ereignistyp/Kategorie der Widerrufe</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.corrisimport.html">Corris-Import</RouteLink></p>
</div></template>


